module.exports = __webpack_public_path__ + "static/media/icon-eye-white.d4b04fab.svg";